'use client';

// 1. Definimos un estado inicial vacío y seguro para el servidor
export const initialState = {
	userName: '',
	token: '',
	loading: false,
	errorMessage: null,
	subdomain: '',
	idSuscripcion: 0,
	idEmpresa: 0,
	idioma: ''
};

// 2. Función auxiliar para obtener datos de localStorage de forma segura
export const getStoredAuth = () => {
    if (typeof window === 'undefined') return initialState;
    
    try {
        const currentUser = window.localStorage.getItem('currentUser');
        if (currentUser) {
            const parsed = JSON.parse(currentUser);
            return {
                ...initialState,
                userName: parsed.userName || '',
                token: parsed.token || '',
                subdomain: parsed.subdomain || '',
                idSuscripcion: parsed.idSuscripcion || 0,
                idEmpresa: parsed.idEmpresa || 0,
                idioma: parsed.idioma || ''
            };
        }
    } catch (error) {
        console.error("Error parsing user from localStorage", error);
    }
    return initialState;
};

export const AuthReducer = (state, action) => {
	switch (action.type) {
		case 'REQUEST_LOGIN':
			return { ...state, loading: true };
		case 'LOGIN_SUCCESS':
            // Guardar en localStorage cuando el login es exitoso
            window.localStorage.setItem('currentUser', JSON.stringify(action.payload));
			return {
				...state,
				userName: action.payload.userName,
				token: action.payload.token,
				idEmpresa: action.payload.idEmpresa,
				idioma: action.payload.idioma,
				loading: false,
			};
		case 'LOGOUT':
            window.localStorage.removeItem('currentUser');
			return initialState;
		case 'LOGIN_ERROR':
			return { ...state, loading: false, errorMessage: action.error };
		case 'CONFIG_SUBDOMAIN':
			return {
				...state,
				idEmpresa : action.payload.idEmpresa,
				idSuscripcion : action.payload.idSuscripcion,
				idioma: action.payload.idioma,
				subdomain: action.payload.subdomain
			};
		default:
			throw new Error(`Unhandled action type: ${action.type}`);
	}
};